<template>
  <v-container>
    <v-card 
    >
    <v-carousel cycle>
      <v-carousel-item
        v-for="(color, i) in colors"
        :key="color"
      >
        <v-sheet
          :color="color"
          height="100%"
          tile
        >
          <v-img v-if="i == 0" src="../assets/img/first-page1.png" aspect-ratio="2.5"></v-img>
          <v-img v-if="i == 1" src="../assets/img/laravel.png" aspect-ratio="3.2"></v-img>
          <v-img v-if="i == 2" src="../assets/img/vue.jpg" aspect-ratio="2.5"></v-img>
          <v-img v-if="i == 3" src="../assets/img/vuetify.png" aspect-ratio="2.5"></v-img>
          <v-img v-if="i == 4" src="../assets/img/aws.jpg" aspect-ratio="2.5"></v-img>
          <v-img v-if="i == 5" src="../assets/img/mysql.png" aspect-ratio="2.5"></v-img>
          <v-row
            class="fill-height"
            align="center"
            justify="center"
          >
            
            <div class="display-1"> I AM SIMPLE, EASY TO ACCESS, EAGER TO LEARN & SHARE </div>
          </v-row>
        </v-sheet>
      </v-carousel-item>
    </v-carousel>
    <v-list two-line>
        <v-list-item>
          <v-list-item-avatar>
            <v-img src="../assets/img/shishir.png"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold headline indigo--text accent-4">Ziaur Rahman</v-list-item-title>
            <v-list-item-subtitle class="black--text title">Full Stack Web Developer</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>

    <div class="mt-5">
      <v-card class="d-flex justify-space-between mb-6" color="blue-grey lighten-2">
        <v-card class="row ma-5">
              <v-card-text>
                <div class="font-weight-bold black--text headline">About myself</div>
                <p class="font-italic black--text subtitle-1">
                  I have 4+ experience as a software engineer. I am an excellent team player and team builder. I'm a hands-on technical leader who has built software products from the ground up, run small engineering teams, and provided guidance at the executive and board level. I'm motivated by product success and business growth, not technology for technology's sake.
                </p>
              </v-card-text>
        </v-card>
        <v-card class="row ma-5">
              <v-card-text>
                <div class="font-weight-bold black--text accent-4 headline">Motivation</div>
                <p class="font-italic black--text subtitle-1">
                  Desire for creating somthing new. Learning new stuff and evloving. Making a work of Art. Taking new challenges. Getting work done. Improving self worth in the market. Being in position of influence. Beleiving in myself and product. Being respected by the work to the world. Working with intelligent and awesome people.
                </p>
              </v-card-text>
        </v-card>
      </v-card>
    </div>

    <div class="mt-2">
      <v-card class="d-flex justify-space-between mb-6" color="blue-grey lighten-2">
        <v-card class="row ma-5">
             <v-card >
               <v-card-text>
                  <div class="font-weight-bold black--text headline accent-4">Skills</div>
                  <p class="font-italic black--text subtitle-1">
                    An excellent team player with a positive attitude. Able to make web apps (full stack) and also use api, PHP(Laravel), JAVASCRIPT, HTML and other programming languages to complete work. Highly organized and detail-oriented professional with 4+ years of progressive experience in the field. Seeking a role building Web and module based applications for a well-established software company.
                  </p>
                </v-card-text>
             </v-card>
              <v-card class="row ma-5" color="blue-grey lighten-4">
                    <v-card-text>
                      <p class="font-weight-bold subtitle-1 black--text">Laravel</p>
                    </v-card-text>
              </v-card>
              <v-card class="row ma-5" color="blue-grey lighten-4">
                    <v-card-text>
                      <p class="font-weight-bold subtitle-1 black--text">Vue js</p>
                    </v-card-text>
              </v-card>
              <v-card class="row ma-5" color="blue-grey lighten-4">
                    <v-card-text>
                      <p class="font-weight-bold subtitle-1 black--text">Vuetify</p>
                    </v-card-text>
              </v-card>
              <v-card class="row ma-5" color="blue-grey lighten-4">
                    <v-card-text>
                      <p class="font-weight-bold subtitle-1 black--text">AWS</p>
                    </v-card-text>
              </v-card>
              <v-card class="row ma-5" color="blue-grey lighten-4">
                    <v-card-text>
                      <p class="font-weight-bold subtitle-1 black--text">MySQL</p>
                    </v-card-text>
              </v-card>
              <v-card class="row ma-5" color="blue-grey lighten-4">
                    <v-card-text>
                      <p class="font-weight-bold subtitle-1 black--text">Firebase</p>
                    </v-card-text>
              </v-card> 
              <v-card class="row ma-5" color="blue-grey lighten-4">
                    <v-card-actions>
                      <v-btn
                        text
                        color="black"
                        class="font-italic subtitle-2"
                        to="/skill"
                      >
                        See Details
                      </v-btn>
                    </v-card-actions>
              </v-card>        
              
        </v-card>
      </v-card>
    </div>

    <div class="mt-2">
      <v-card class="d-flex justify-space-between mb-6" color="blue-grey lighten-2">
        <v-card class="row ma-5">
            <v-card>
              <v-card-text>
                <div class="font-weight-bold headline black--text accent-4">Projects</div>
                <p class="font-italic subtitle-1 black--text">
                  I have worked some excellent and innovative idea in these years. Specially in finance and socio-economic projects. Now, i am working on a fintech solution that is Bangladesh's first peer to peer lending platform and survey app named datadash. Also worked in microfinance and cooperative society. I have worked on education erp, accounting erp, billing system and also vote canvas software project.
                </p>
              </v-card-text>
            </v-card>
            <v-card class="row ma-5" color="blue-grey lighten-4">
                    <v-card-text>
                      <p class="font-weight-bold subtitle-2 black--text">shadhin</p>
                    </v-card-text>
              </v-card>
              <v-card class="row ma-5" color="blue-grey lighten-4">
                    <v-card-text>
                      <p class="font-weight-bold subtitle-2 black--text">shadhin investor</p>
                    </v-card-text>
              </v-card>
              <v-card class="row ma-5" color="blue-grey lighten-4">
                    <v-card-text>
                      <p class="font-weight-bold subtitle-2 black--text">datadash</p>
                    </v-card-text>
              </v-card>
              <v-card class="row ma-5" color="blue-grey lighten-4">
                    <v-card-text>
                      <p class="font-weight-bold subtitle-2 black--text">email marketing</p>
                    </v-card-text>
              </v-card>
              <v-card class="row ma-5" color="blue-grey lighten-4">
                    <v-card-text>
                      <p class="font-weight-bold subtitle-2 black--text">url shortening</p>
                    </v-card-text>
              </v-card>
              <v-card class="row ma-5" color="blue-grey lighten-4">
                    <v-card-text>
                      <p class="font-weight-bold subtitle-2 black--text">vote canvas</p>
                    </v-card-text>
              </v-card>
              <v-card class="row ma-5" color="blue-grey lighten-4">
                    <v-card-actions>
                      <v-btn
                        text
                        color="black"
                        class="font-italic subtitle-2"
                        to="/project"
                      >
                        See Details
                      </v-btn>
                    </v-card-actions>
              </v-card> 
        </v-card>
      </v-card>
    </div>


    <div class="mt-2">
      <v-card class="d-flex justify-space-between mb-6" color="blue-grey lighten-2">
        <v-card class="row ma-5">
              <v-card-text>
                <div class="font-weight-bold headline black--text accent-4">Experiences</div>
                <p class="font-italic subtitle-1 black--text">
                  Gathering experienced working in giant ngo in Bangladesh like TMSS, medium level software firm like gurukul and ctmt ltd and shadhin fintech solution limited. I have got experienced some outstanding guy in the field of team leader, project manager, system analyst, server administrator, programmers, credit specialist and finance advisors. Getting enlarge my communication, management and coding capabilities from these intelligent guy and companies.
                </p>
              </v-card-text>
              <!-- <v-card-actions color="blue-grey lighten-4">
                <v-btn
                  text
                  color="black accent-4"
                  class="font-italic subtitle-1"
                  to="/experience"
                >
                  See Details
                </v-btn>
              </v-card-actions> -->
        </v-card>
        <v-card class="row ma-5" color="blue-grey lighten-4">
                <v-card-actions>
                    <v-btn
                    text
                    color="black accent-4"
                    class="font-italic subtitle-1"
                    to="/experience"
                  >
                    See Details
                  </v-btn>
                </v-card-actions>
          </v-card>
      </v-card>
    </div>

    <!-- <div class="mt-2">
      <v-card class="d-flex justify-space-between mb-6">
        <v-card class="row ma-5">
              <v-card-text>
                <div class="font-weight-bold indigo--text accent-4">Acquisitions</div>
                <p class="text-example font-italic black--text">
                  An excellent team player with a positive attitude. Able to make web apps (full stack) and also use api, PHP(Laravel), JAVASCRIPT, HTML and other programming languages to complete work. Highly organized and detail-oriented professional with 4+ years of progressive experience in the field. Seeking a role building Web and module based applications for a well-established software company.
                </p>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  text
                  color="indigo accent-4"
                  class="font-italic"
                >
                  See Details
                </v-btn>
              </v-card-actions>
        </v-card>
      </v-card>
    </div> -->

    <div class="mt-2">
      <v-card class="d-flex justify-space-between mb-6" color="blue-grey lighten-2">
        <v-card class="row ma-5">
              <v-card-text>
                <div class="font-weight-bold headline black--text accent-4">Blogs</div>
                <p class="font-italic subtitle-1 black--text">
                  Blogs today have become an essential part and needed for most of the generation worldwide. Life was never so tech savvy before this. Whether one needs advice, needs to share personal experience, be aware of the views on any topic, all one needs is to gear up and punch in a few keys and write a blog. I have blogs named curio. I am very much willing to spread my knowledge. When i got solved a problem, i share it to the people so that anyone can get the solution easily. 
                </p>
              </v-card-text>
              <v-card-actions >
                <a href="https://www.zrshishir.blogspot.com" target="blank">
                      <v-btn
                        text
                        class="font-weight-bold subtitle-1 font-italic"
                      >
                        CURIO
                      </v-btn>
                </a>
              </v-card-actions>
              <v-card-actions>
                    <a href="https://medium.com/@zrshishir" target="blank">
                      <v-btn
                        text
                        class="font-weight-bold subtitle-1 font-italic"
                      >
                        medium
                      </v-btn>
                    </a>
                  </v-card-actions>
              <v-card-actions>
                <a href="http://zrshisir.blogspot.com/" target="blank">
                      <v-btn
                        text
                        class="font-weight-bold subtitle-1 font-italic"
                      >
                        blog
                      </v-btn>
                </a>
              </v-card-actions>
        </v-card>
      </v-card>
    </div>

    <div class="mt-2">
      <div class="d-flex flex-column mb-6">
          <v-card
            class="pa-2 font-weight-bold headline black--text"
            
            outlined
            tile
          >
            Follow me on 
          </v-card>
          <v-card class="d-flex justify-space-between mb-6" color="blue-grey lighten-2">
            <v-card class="row ma-5">
                  <v-card-actions>
                    <a href="https://www.linkedin.com/in/ziaur-rahman-556330121" target="blank">
                      <v-btn
                        text
                        class="font-weight-bold subtitle-1 font-italic"
                      >
                        linkedin
                      </v-btn>
                    </a>
                  </v-card-actions>
            </v-card>
            <v-card class="row ma-5">
                  <v-card-actions>
                    <a href="https://stackoverflow.com/users/4472398/ziaur-rahman" target="blank">
                      <v-btn
                        text
                        class="font-weight-bold subtitle-1 font-italic"
                      >
                        stack overflow
                      </v-btn>
                    </a>
                  </v-card-actions>
            </v-card>
            <v-card class="row ma-5">
                  <v-card-actions>
                    <a href="https://github.com/zrshishir" target="blank">
                      <v-btn
                        text
                        class="font-weight-bold subtitle-1 font-italic"
                      >
                        github
                      </v-btn>
                    </a>
                  </v-card-actions>
            </v-card>
            <v-card class="row ma-5">
                  <v-card-actions>
                    <a href="https://www.facebook.com/ziaur.rahman.7921975" target="blank">
                      <v-btn
                        text
                        class="font-weight-bold subtitle-1 font-italic"
                      >
                        facebook
                      </v-btn>
                    </a>
                  </v-card-actions>
            </v-card>
            <v-card class="row ma-5">
                  <v-card-actions>
                    <a href="https://medium.com/@zrshishir" target="blank">
                      <v-btn
                        text
                        class="font-weight-bold subtitle-1 font-italic"
                      >
                        medium
                      </v-btn>
                    </a>
                  </v-card-actions>
            </v-card>
            <v-card class="row ma-5">
                  <v-card-actions>
                    <a href="https://twitter.com/zrshishir" target="blank">
                      <v-btn
                        text
                        class="font-weight-bold subtitle-1 font-italic"
                      >
                        twitter
                      </v-btn>
                    </a>
                  </v-card-actions>
            </v-card>
          </v-card>
      </div>
    </div>

  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        colors: [
          'primary',
          'red',
          'secondary',
          'white',
          'yellow darken-2',
          'primary',
          'indigo'
        ],
      }
    },
  }
</script>
<style lang="sass">
  .text-example
    background-color: #B3E5FC
    border: 1px solid rgba(86, 61, 124,.15)

  .big-card
    background-color: #0D47A1
    border: 1px
  
</style>